import * as React from "react";
import PropTypes from "prop-types";

// coraWebComponents
import RadioGroup from "../../coraWebComponents/forms/RadioGroup";
import MaskedTextBox from "../../coraWebComponents/forms/MaskedTextBox";
import Input from "../../coraWebComponents/forms/Input";

// proptypes
import userPropTypes from "../../propTypes/userPropTypes";


class InfoData extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      radioData: [
        { label: "Fyzická osoba", value: "fyzOsoba" },
        { label: "Právnická osoba", value: "pravOsoba" },
      ],
      titles: {
        meno: "Meno",
        priezvisko: "Priezvisko",
        nazov: "Názov",
        ico: "IČO",
        ulica: "Ulica",
        cs: "Číslo súpisné",
        co: "Číslo orientačné",
        psc: "Poštové smerodajné číslo",
        obec: "Obec",
        email: "Email",
        telefon: "Telefón",
      },
    };
  }

  render() {
    const { titles, radioData } = this.state;
    const { mobile, infoData, onChange, emailDisabled } = this.props;

    return (
      <>
        {/* FIELDS */}
        {/* READIO GROUP */}
        <RadioGroup
          textField="label"
          dataItemKey="value"
          value={infoData.radioValue}
          data={radioData}
          name="radioValue"
          layout="horizontal"
          onChange={onChange}
        />
        {/* MENO, PRIEZVISKO, NAZOV, ICO */}
        {infoData.radioValue.value === "fyzOsoba" && (
          <>
            {/* MENO */}
            <div className="k-form-field">
              <span>{"*Meno"}</span>
              <Input
                title={titles.meno}
                type="text"
                name="meno"
                onChange={onChange}
                value={infoData.meno}
                required
              />
            </div>
            {/* PRIEZVISKO */}
            <div className="k-form-field">
              <span>{"*Priezvisko"}</span>
              <Input
                title={titles.priezvisko}
                type="text"
                name="priezvisko"
                onChange={onChange}
                value={infoData.priezvisko}
                required
              />
            </div>
          </>
        )}
        {infoData.radioValue.value !== "fyzOsoba" && (
          <>
            <div className="k-form-field">
              <span>{"*Názov"}</span>
              <Input
                title={titles.nazov}
                type="text"
                name="nazov"
                onChange={onChange}
                value={infoData.nazov}
                required
              />
            </div>
            <div className="k-form-field">
              <span>{"*IČO"}</span>
              <Input
                title={titles.ico}
                type="text"
                name="ico"
                onChange={onChange}
                value={infoData.ico}
                required
              />
            </div>
          </>
        )}
        {/* ULICA */}
        <div className="k-form-field">
          <span>{"Ulica"}</span>
          <Input
            title={titles.ulica}
            type="text"
            name="ulica"
            onChange={onChange}
            value={infoData.ulica}
          />
        </div>

        {mobile &&
          <>
            {/* CS */}
            <div className="k-form-field">
              <span>{"*ČS"}</span>
              <Input
                title={titles.cs}
                type="number"
                name="cs"
                onChange={onChange}
                value={infoData.cs}
                required
              />
            </div>
            {/* CO */}
            <div className="k-form-field">
              <span>{"ČO"}</span>
              <Input
                title={titles.co}
                type="text"
                name="co"
                onChange={onChange}
                value={infoData.co}
              />
            </div>
            {/* PSC*/}
            <div className="k-form-field">
              <span>{"*PSČ:"}</span>
              <MaskedTextBox
                title={titles.psc}
                name="psc"
                value={infoData.psc}
                onChange={onChange}
                mask="000 00"
                required
              />
            </div>
            {/* OBEC*/}
            <div className="k-form-field">
              <span>{"*Obec:"}</span>
              <Input
                title={titles.obec}
                type="text"
                name="obec"
                value={infoData.obec}
                onChange={onChange}
                required
              />
            </div>
          </>
        }
        {!mobile &&
          <>
            {/* CS/CO */}
            <div
              className="k-form-field flexGroup"
              style={{ marginTop: "0px" }}
            >
              <div
                className="k-form-field flex1"
                style={{ padding: "0px 5px 0px 0px" }}
              >
                <span>{"*ČS"}</span>
                <Input
                  title={titles.cs}
                  type="number"
                  name="cs"
                  onChange={onChange}
                  value={infoData.cs}
                  required
                />
              </div>
              <div
                className="k-form-field flex1"
                style={{ padding: "0px 0px 0px 5px" }}
              >
                <span>{"ČO"}</span>
                <Input
                  title={titles.co}
                  type="text"
                  name="co"
                  onChange={onChange}
                  value={infoData.co}
                />
              </div>
            </div>
            {/* PSC/OBEC*/}
            <div
              className="k-form-field flexGroup"
              style={{ marginTop: "0px" }}
            >
              <div
                className="k-form-field flex1"
                style={{ padding: "0px 5px 0px 0px" }}
              >
                <span>{"*PSČ:"}</span>
                <MaskedTextBox
                  title={titles.psc}
                  name="psc"
                  value={infoData.psc}
                  onChange={onChange}
                  mask="000 00"
                  required
                />
              </div>
              <div
                className="k-form-field flex2"
                style={{ padding: "0px 0px 0px 5px" }}
              >
                <span>{"*Obec:"}</span>
                <Input
                  title={titles.obec}
                  type="text"
                  name="obec"
                  value={infoData.obec}
                  onChange={onChange}
                  required
                />
              </div>
            </div>
          </>
        }
        {/* EMAIL */}
        <div className="k-form-field">
          <span>{"*Email"}</span>
          <Input
            title={titles.email}
            type="email"
            name="email"
            onChange={onChange}
            value={infoData.email}
            disabled={emailDisabled ? true : false}
            required
          />
        </div>
        {/* TELEFON */}
        <div className="k-form-field">
          <span>{"*Telefón"}</span>
          <Input
            title={titles.telefon}
            type="tel"
            placeholder="+421999999999"
            pattern="([+]\d{3}\s\d{3}\s\d{3}\s\d{3}|[0]{2}\d{3}\s\d{3}\s\d{3}\s\d{3})|(^\d{4}\s\d{3}\s\d{3}$)|(^\d{10}$)|([+]\d{12}|[0]{2}\d{12})|([+]\d{2}\s\d{3}\s\d{3}\s\d{4}|[0]{2}\d{2}\s\d{3}\s\d{3}\s\d{4})|([+]\d{2}\s\d{2}\s\d{4}\s\d{4}|[0]{2}\d{2}\s\d{2}\s\d{4}\s\d{4})|([+]\d{3}\s\d{2}.\d{3}\s\d{2}\s\d{2}|[0]{2}\d{3}\s\d{2}.\d{3}\s\d{2}\s\d{2})|([0]\d{2}.\d{3}\s\d{2}\s\d{2})|([+]\d{3}\s\d{2}.\d{7}|[0]{2}\d{3}\s\d{2}.\d{7})|([0]\d{2}.\d{7}$)"
            validationMessage="Nesprávny formát telefónneho čísla"
            name="telefon"
            onChange={onChange}
            value={infoData.telefon}
            required
          />
        </div>
      </>
    );
  }
}


InfoData.propTypes = {
  infoData: userPropTypes.user,
  onChange: PropTypes.func.isRequired,
  mobile: PropTypes.bool,
  emailDisabled: PropTypes.bool,
};

export default InfoData;
